import { BehaviorSubject } from 'rxjs';

import DiscountPopup from '../components/discounts/DiscountPopup';
import RemoveDiscountPopup from '../components/discounts/RemoveDiscountPopup';

export const discountsDefaultCriteria = {
  limit: '10',
  orderField: 'name',
  orderType: 'ASC',
  page: 0,
};

export default class DiscountsBloc {
  isLoading$ = new BehaviorSubject(false);
  total$ = new BehaviorSubject(0);
  searchCriteria$ = new BehaviorSubject(discountsDefaultCriteria);
  discounts$ = new BehaviorSubject([]);

  constructor({ discountsRepository, dialogRepository, errorRepository }) {
    this.discountsRepository = discountsRepository;
    this.dialogRepository = dialogRepository;
    this.errorRepository = errorRepository;

    this.searchSubscription = this.searchCriteria$.subscribe(() => {
      this.getDiscounts();
    });
  }

  dispose() {
    this.searchSubscription.unsubscribe();
  }

  async getDiscounts() {
    const { data, total } = await this.discountsRepository.getDiscounts(this.searchCriteria$.getValue());
    this.discounts$.next(data);
    this.total$.next(total);
  }

  updateSearchCriteria(updatedCriteria) {
    this.searchCriteria$.next({
      ...this.searchCriteria$.getValue(),
      ...updatedCriteria,
    });
  }

  openAddDiscountPopup() {
    this.dialogRepository.loadDialog(DiscountPopup, {
      code: '',
      name: '',
      onCancel: () => this.dialogRepository.toggleDialog(false),
      onConfirm: (data) => this.handleAddDiscount(data),
    });
  }

  async handleAddDiscount(data) {
    try {
      await this.discountsRepository.createDiscount(data);
      this.dialogRepository.toggleDialog(false);
      this.getDiscounts();
    } catch (error) {
      this.errorRepository.error$.next({
        message: error.message || 'Failed to create discount!',
        severity: 'error',
      });
    }
  }

  openEditDiscountPopup(id) {
    const discounts = this.discounts$.getValue();
    const discount = discounts.find((item) => item.id === id);
    if (!discount?.id) return;

    this.dialogRepository.loadDialog(DiscountPopup, {
      code: discount.code,
      isUpdate: true,
      name: discount.name,
      onCancel: () => this.dialogRepository.toggleDialog(false),
      onConfirm: (data) => this.handleUpdateDiscount(id, data),
    });
  }

  async handleUpdateDiscount(id, data) {
    try {
      await this.discountsRepository.updateDiscount(id, data);
      this.dialogRepository.toggleDialog(false);
      this.getDiscounts();
    } catch (error) {
      this.errorRepository.error$.next({
        message: error.message || 'Failed to update discount!',
        severity: 'error',
      });
    }
  }

  openRemoveDiscountPopup(id) {
    const discounts = this.discounts$.getValue();
    const discount = discounts.find((item) => item.id === id);
    if (!discount?.id) return;

    this.dialogRepository.loadDialog(RemoveDiscountPopup, {
      code: discount.code,
      isUpdate: true,
      name: discount.name,
      onCancel: () => this.dialogRepository.toggleDialog(false),
      onConfirm: () => this.handleRemoveDiscount(discount.id),
    });
  }

  async handleRemoveDiscount(id) {
    try {
      await this.discountsRepository.removeDiscount(id);
      this.dialogRepository.toggleDialog(false);
      this.getDiscounts();
    } catch (error) {
      this.errorRepository.error$.next({
        message: error.message || 'Failed to remove discount!',
        severity: 'error',
      });
    }
  }
}
